import { Card, Col, Form, Input, Row, Select } from "antd";
import React from "react";
import ViewData from "./ViewData";
import { EyeOutlined } from "@ant-design/icons";
import {
  BusinessNaturesTypeOptions,
  BusinessTypeOptions,
} from "../../Clients/Clients";
import { AccountTypeDropDown, BankAccountType_New } from "../../../Services/Vendor/VendorRegistrationService";

const VendorDetailsModal = () => {
  const [form] = Form.useForm();
  const [isModelOpen, setIsModelOpen] = React.useState<boolean>(false);

  return (
    <>
      <div>
        <Card size="small">
          <Form form={form} labelAlign="left" size="middle">
            <Card
              size="small"
              title="Basic Information"
              style={{ width: "100%" }}
              type="inner"
            >
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    style={{ margin: "0px 0px 10px 0px" }}

                    // className="inputBoxMb"
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Organization Id
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Organization Name
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        overflow: "hidden",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          width: "173px",
                          textAlign: "start",
                          backgroundColor: "rgba(0, 0, 0, 0.02)",
                          borderRight: "1px solid #d9d9d9",
                          lineHeight: "32px",
                          padding: "0 12px",
                        }}
                      >
                        Business Type
                      </span>

                      <Select
                        placeholder="Select"
                        mode="multiple"
                        options={BusinessTypeOptions}
                        style={{
                          flex: 1,
                          border: "none",
                        }}
                        bordered={false}
                      />
                    </div>
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        overflow: "hidden",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          width: "173px",
                          textAlign: "start",
                          backgroundColor: "rgba(0, 0, 0, 0.02)",
                          borderRight: "1px solid #d9d9d9",
                          lineHeight: "32px",
                          padding: "0 12px",
                        }}
                      >
                        Business Nature
                      </span>

                      <Select
                        placeholder="Select"
                        mode="multiple"
                        options={BusinessNaturesTypeOptions}
                        style={{
                          flex: 1,
                          border: "none",
                        }}
                        bordered={false} // Remove default Select border
                      />
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Business Start Date
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Type of Address
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Address
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card
              size="small"
              title="Contact Information"
              style={{ width: "100%", margin: "15px  0px" }}
              type="inner"
            >
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Contact Person
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Designation
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 15px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Phone
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Website
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Email To
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Email CC
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card
              size="small"
              title="Statutory Information"
              style={{ width: "100%" }}
              type="inner"
            >
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          GST Type
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          GSTIN
                        </span>
                      }
                      suffix={
                        <div style={{ paddingRight: "10px" }}>
                          <EyeOutlined onClick={() => setIsModelOpen(true)} />
                        </div>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          PAN
                        </span>
                      }
                      suffix={
                        <p
                          style={{
                            color: "#0d99ff",
                            paddingRight: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => setIsModelOpen(true)}
                        >
                          View
                        </p>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Udhyam Aadhar
                        </span>
                      }
                      suffix={
                        <p
                          style={{
                            color: "#0d99ff",
                            paddingRight: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => setIsModelOpen(true)}
                        >
                          View
                        </p>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card
              size="small"
              title="Bank Detail"
              style={{ width: "100%", margin: "15px  0px" }}
              type="inner"
            >
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Account Holder Name
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Account Number
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        overflow: "hidden",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          width: "173px",
                          textAlign: "start",
                          backgroundColor: "rgba(0, 0, 0, 0.02)",
                          borderRight: "1px solid #d9d9d9",
                          lineHeight: "32px",
                          padding: "0 12px",
                        }}
                      >
                        Bank Account Type
                      </span>

                      <Select
                        placeholder="Select"
                        options={AccountTypeDropDown}
                        style={{
                          flex: 1,
                          border: "none",
                        }}
                        bordered={false}
                      />
                    </div>
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Bank Name
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          IFSC Code
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          Branch
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item style={{ margin: "0px 0px 10px 0px" }}>
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "150px",
                            textAlign: "left",
                          }}
                        >
                          UPI Id
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Card
              size="small"
              title="Other Documents"
              style={{ width: "100%" }}
              type="inner"
            >
              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          ISO Quality Certificate
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                View
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Reject
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          FSSAI License
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                View
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Reject
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          Audited Balance Sheet
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Not Available
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                Send Request
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          Turnover Details
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                View
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Reject
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          Import Export Certificate (IEC)
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                View
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Reject
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          Memorandum of Association
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                View
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Reject
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          IncorPoration Certificate Number
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                View
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Reject
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          Plant & Machinery List
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                View
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Reject
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          Testing Equipment List
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                View
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Reject
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 6 }}
                    style={{ margin: "0px 0px 10px 0px" }}
                  >
                    <Input
                      addonBefore={
                        <span
                          style={{
                            display: "inline-block",
                            width: "220px",
                            textAlign: "left",
                          }}
                        >
                          Clientage Detail
                        </span>
                      }
                      suffix={
                        <>
                          <Row gutter={12}>
                            <Col>
                              <p
                                style={{
                                  color: "#0d99ff",
                                  paddingRight: "10px",
                                }}
                              >
                                View
                              </p>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  color: "red",
                                  paddingRight: "10px",
                                }}
                              >
                                Reject
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Form>
        </Card>
      </div>

      {isModelOpen && (
        <ViewData
          onCancel={() => setIsModelOpen(false)}
          isModelOpen={isModelOpen}
        />
      )}
    </>
  );
};

export default VendorDetailsModal;
